import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { Table, ProgressBar } from 'react-bootstrap';
import { get, values } from 'lodash';

import Image from '../../components/Image';
import RichTextDisplay from '../../components/RichTextDisplay';
import TrackPlayerSlideComponent from '../../hocs/TrackPlayerSlideComponent';
import { round10 } from '../../utils/NumberUtils';
import VerbText from '../../components/VerbText';
import WorkspaceSlideHeader from './WorkspaceSlideHeader';

class ChooseOneResultsSlide extends Component {
    static propTypes = {
        name: PropTypes.string,
        content: PropTypes.shape({
            description: PropTypes.string,
            chooseOneSectionItemId: PropTypes.string
        }),
        currentUser: PropTypes.object,
        completedData: PropTypes.object,
        canMoveToNext: PropTypes.func,
        canMoveToPrevious: PropTypes.func,
        chooseOneContent: PropTypes.shape({
            options: PropTypes.array,
            description: PropTypes.string,
            displayType: PropTypes.string
        }),
        chooseOneData: PropTypes.shape({
            data: PropTypes.string
        }),
        globalResults: PropTypes.object,
        nextSectionName: PropTypes.string,
        onChange: PropTypes.func,
        sectionId: PropTypes.string,
        hideBookmark: PropTypes.bool,
        sectionItemId: PropTypes.string,
        sendWorkspaceSegementEvent: PropTypes.func,
        isRefSheet: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.state = {
            selectChoice: props.completedData ? props.completedData.data : null
        };
    }

    componentDidMount() {
        const { canMoveToPrevious, canMoveToNext, onChange } = this.props;

        const isCompleted = true;

        const isAnswered = true;

        if (canMoveToPrevious) {
            canMoveToPrevious(true);
        }
        if (canMoveToNext) {
            canMoveToNext(true);
        }
        if (onChange) {
            onChange(null, isCompleted, isAnswered);
        }
    }

    /**
     *
     * @return {Array}
     * @private
     */
    _buildDisplayOptions = () => {
        const { chooseOneContent, chooseOneData, globalResults } = this.props;

        const totalCount = values(globalResults).reduce((a, b) => a + b, 0);
        let runningTotalPercentage = 0;

        // chooseOneData.data is the currentUser's selected value
        const chooseOneOptions = get(chooseOneContent, 'options', []) || [];

        const displayOptions = chooseOneOptions.map((option) => {
            const mappedDisplayOption = {};

            mappedDisplayOption.id = option.choice;
            mappedDisplayOption.label = option.label;

            if (chooseOneContent.displayType === 'image') {
                mappedDisplayOption.imageUrl = option.image;
            }

            if (
                totalCount <= 0 ||
                !(mappedDisplayOption.id in globalResults) ||
                globalResults[mappedDisplayOption.id] <= 0
            ) {
                mappedDisplayOption.percentage = 0;
            } else {
                mappedDisplayOption.percentage = round10((globalResults[mappedDisplayOption.id] / totalCount) * 100);
            }

            runningTotalPercentage += mappedDisplayOption.percentage;

            mappedDisplayOption.userSelected = mappedDisplayOption.id === chooseOneData.data;

            return mappedDisplayOption;
        });

        // This is an appearance hack to always make our percentages add to 100...no matter what
        if (runningTotalPercentage !== 100) {
            displayOptions[0].percentage += 100 - runningTotalPercentage;
        }

        return displayOptions;
    };

    render() {
        const {
            name,
            currentUser,
            nextSectionName,
            content: { description = '' },
            sectionId,
            sectionItemId,
            hideBookmark,
            sendWorkspaceSegementEvent,
            isRefSheet = false,
        } = this.props;
        const displayOptions = this._buildDisplayOptions();

        return (
            <div className={'chooseOneResultSlide'}>
                <WorkspaceSlideHeader
                    headerText={name}
                    currentSectionItemId={sectionItemId}
                    currentSectionId={sectionId}
                    currentUser={currentUser}
                    hideBookmark={hideBookmark}
                    isRefSheet={isRefSheet}
                />
                <div className={cns('chooseOneResultSlide-options', 'playerContent')}>
                    <RichTextDisplay
                        className={'playerDescription'}
                        htmlToDisplay={description}
                        currentUser={currentUser}
                        nextSectionName={nextSectionName}
                    />
                    <div
                        className={cns(
                            'col-12',
                            'col-sm-12',
                            'col-md-offset-1',
                            'col-md-10',
                            'col-lg-offset-2',
                            'col-lg-8',
                            'centerTable'
                        )}
                    >
                        <Table className={'adminTable'}>
                            <thead>
                                <tr>
                                    <th>
                                        <VerbText messageId={'WORKSPACE_CHOOSEONE_ANSWER'} defaultMessage={'Answer'} />
                                    </th>
                                    <th>
                                        <VerbText
                                            messageId={'WORKSPACE_CHOOSE_ONE_RESULTS_RESULTS'}
                                            defaultMessage={'Results'}
                                        />
                                    </th>
                                    <th>
                                        <VerbText
                                            messageId={'WORKSPACE_FEEDBACK_YOUR_ANSWER'}
                                            defaultMessage={'Your answer'}
                                        />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {displayOptions.map((displayOption) => (
                                    <tr key={displayOption.id}>
                                        <td>
                                            {displayOption.label}
                                            <Image src={displayOption.imageUrl} dimension={{ w: 40, h: 40 }} />
                                        </td>
                                        <td>
                                            <ProgressBar
                                                label={
                                                    <div className={'progressBarMargin'}>
                                                        {displayOption.percentage}%
                                                    </div>
                                                }
                                                now={displayOption.percentage}
                                            />
                                        </td>
                                        <td>
                                            {displayOption.userSelected ? <i className={'fa fa-check fa-fw'} /> : null}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
        );
    }
}

export const ChooseOneResultsSlideComponent = ChooseOneResultsSlide;
export default TrackPlayerSlideComponent(ChooseOneResultsSlide);
